function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1096 28.0625L7.65547 23.9292L3.00547 22.8958L3.45755 18.1167L0.292969 14.5L3.45755 10.8833L3.00547 6.10417L7.65547 5.07083L10.1096 0.9375L14.5013 2.81042L18.893 0.9375L21.3471 5.07083L25.9971 6.10417L25.5451 10.8833L28.7096 14.5L25.5451 18.1167L25.9971 22.8958L21.3471 23.9292L18.893 28.0625L14.5013 26.1896L10.1096 28.0625ZM11.2076 24.7688L14.5013 23.3479L17.8596 24.7688L19.668 21.6687L23.2201 20.8292L22.8971 17.2125L25.2867 14.5L22.8971 11.7229L23.2201 8.10625L19.668 7.33125L17.7951 4.23125L14.5013 5.65208L11.143 4.23125L9.33464 7.33125L5.78255 8.10625L6.10547 11.7229L3.71589 14.5L6.10547 17.2125L5.78255 20.8938L9.33464 21.6687L11.2076 24.7688ZM13.1451 19.0854L20.443 11.7875L18.6346 9.91458L13.1451 15.4042L10.368 12.6917L8.55964 14.5L13.1451 19.0854Z",
  fill: "#443E99"
});

var SvgVerified = function SvgVerified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Verified.0625b2a0.svg";
export { ForwardRef as ReactComponent };